<template>
    <div class="">
        <div class="chart-header">
            <h5 class="chart-title">{{ title }}</h5>
        </div>
        <div class="card" :style="cardStyle">

            <div class="card-body" :style="bodyStyle">
                <div class="chart-wrapper">


                    <div class="ranking-container" :style="containerStyle">
                        <div class="table-wrapper">
                            <div class="table-header-wrapper" ref="headerWrapper">
                                <table class="table ranking-table">
                                    <thead>
                                        <tr class="table-header-row">
                                            <th class="rank-header">#</th>
                                            <th class="user-header sortable-header" @click="sortBy('name')">
                                                <div class="sortable-header-content">
                                                    <span>Usuario</span>
                                                    <span class="sort-icon">
                                                        <i v-if="sortField === 'name'" :class="sortDirection === 'asc' ? 'fa fa-sort-alpha-asc' : 'fa fa-sort-alpha-desc'"></i>
                                                        <i v-else class="fa fa-sort"></i>
                                                    </span>
                                                </div>
                                            </th>
                                            <th class="time-header sortable-header" @click="sortBy('total_time')">
                                                <div class="sortable-header-content">
                                                    <span>Tiempo de conexión</span>
                                                    <span class="sort-icon">
                                                        <i v-if="sortField === 'total_time'" :class="sortDirection === 'asc' ? 'fa fa-sort-amount-asc' : 'fa fa-sort-amount-desc'"></i>
                                                        <i v-else class="fa fa-sort"></i>
                                                    </span>
                                                </div>
                                            </th>
                                            <th class="downloads-header sortable-header" @click="sortBy('usability_events_download_labels')">
                                                <div class="sortable-header-content">
                                                    <span>Descargas ET</span>
                                                    <span class="sort-icon">
                                                        <i v-if="sortField === 'usability_events_download_labels'" :class="sortDirection === 'asc' ? 'fa fa-sort-numeric-asc' : 'fa fa-sort-numeric-desc'"></i>
                                                        <i v-else class="fa fa-sort"></i>
                                                    </span>
                                                </div>
                                            </th>
                                            <th class="downloads-header sortable-header" @click="sortBy('usability_events_download_fds')">
                                                <div class="sortable-header-content">
                                                    <span>Descargas FDS</span>
                                                    <span class="sort-icon">
                                                        <i v-if="sortField === 'usability_events_download_fds'" :class="sortDirection === 'asc' ? 'fa fa-sort-numeric-asc' : 'fa fa-sort-numeric-desc'"></i>
                                                        <i v-else class="fa fa-sort"></i>
                                                    </span>
                                                </div>
                                            </th>
                                            <th class="downloads-header sortable-header" @click="sortBy('tikeckets_count')">
                                                <div class="sortable-header-content">
                                                    <span>Tickets</span>
                                                    <span class="sort-icon">
                                                        <i v-if="sortField === 'tikeckets_count'" :class="sortDirection === 'asc' ? 'fa fa-sort-numeric-asc' : 'fa fa-sort-numeric-desc'"></i>
                                                        <i v-else class="fa fa-sort"></i>
                                                    </span>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            
                            <div class="table-body-wrapper" ref="bodyWrapper" @scroll="syncScroll">
                                <table class="table ranking-table">
                                    <tbody>
                                        <tr v-for="(user, index) in sortedUsers" :key="user.id || index" class="user-row"
                                            :class="{ 'top-user': index < 3 }">
                                            <td class="rank-cell">
                                                <div class="rank-badge" :class="getRankClass(index)">
                                                    {{ index + 1 }}
                                                </div>
                                            </td>
                                            <td class="user-cell">
                                                <div class="user-info">
                                                    <div class="user-avatar">
                                                        {{ getUserInitials(user.name) }}
                                                    </div>
                                                    <div class="user-details">
                                                        <div class="user-name">{{ toTitleCase(user.name) }}</div>
                                                        <!-- <div class="user-status" v-if="user.status">{{ user.status }}</div> -->
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="time-cell">
                                                <div class="time-info">
                                                    <span class="time-value">{{ formatTime(user.total_time) }}</span>
                                                    <!-- <span class="time-label">conectado</span> -->
                                                </div>
                                            </td>
                                            <td class="downloads-cell">
                                                <div class="downloads-info">
                                                    <span class="downloads-value">{{ animateValue(index + '_labels', 0, user.usability_events_download_labels || 0) }}</span>
                                                </div>
                                            </td>
                                            <td class="downloads-cell">
                                                <div class="downloads-info">
                                                    <span class="downloads-value">{{ animateValue(index + '_fds', 0, user.usability_events_download_fds || 0) }}</span>
                                                </div>
                                            </td>
                                            <td class="downloads-cell">
                                                <div class="downloads-info">
                                                    <span class="downloads-value">{{ animateValue(index + '_tickets', 0, user.tikeckets_count || 0) }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-if="users.length === 0" class="empty-state">
                            <div class="empty-icon">📊</div>
                            <p class="empty-text">No hay datos de usuarios disponibles</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserRanking',
    props: {
        title: {
            type: String,
            required: false,
            default: 'Ranking de usuarios activos'
        },
        users: {
            type: Array,
            required: false,
            default: () => []
        },
        height: {
            type: Number,
            required: false,
            default: null
        }
    },
    data() {
        return {
            animatedDownloads: [],
            sortField: null,
            sortDirection: 'desc'
        };
    },
    computed: {
        // Usuarios ordenados según el campo y dirección seleccionados
        sortedUsers() {
            if (!this.sortField) {
                return this.users;
            }
            
            // Crear una copia del array para no mutar el original
            const usersCopy = [...this.users];
            
            return usersCopy.sort((a, b) => {
                let aValue = a[this.sortField];
                let bValue = b[this.sortField];
                
                if (aValue === null || aValue === undefined) aValue = 0;
                if (bValue === null || bValue === undefined) bValue = 0;
                
                if (this.sortField !== 'name') {
                    aValue = Number(aValue);
                    bValue = Number(bValue);
                }
                
                let comparison = 0;
                if (this.sortField === 'name') {
                    const aStr = this.toTitleCase(aValue ? String(aValue) : '');
                    const bStr = this.toTitleCase(bValue ? String(bValue) : '');
                    comparison = aStr.localeCompare(bStr, 'es', { sensitivity: 'base' });
                } else {
                    comparison = aValue - bValue;
                }
                
                return this.sortDirection === 'asc' ? comparison : -comparison;
            });
        },
        cardStyle() {
            if (this.height) {
                return {
                    height: `${this.height}px`,
                    display: 'flex',
                    flexDirection: 'column'
                }
            }
            return {}
        },
        bodyStyle() {
            if (this.height) {
                return {
                    maxHeight: `${this.height}px`
                }
            }
            return {}
        },
        containerStyle() {
            return {}
        }
    },
    mounted() {
        this.initAnimatedDownloads();
    },
    watch: {
        users: {
            handler() {
                this.initAnimatedDownloads();
            },
            deep: true
        }
    },
    methods: {
        // Maneja el ordenamiento al hacer clic en los encabezados
        sortBy(field) {
            if (this.sortField === field) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortField = field;
                this.sortDirection = 'desc';
            }
            
            this.initAnimatedDownloads();
        },
        // Convierte una cadena a formato Title Case considerando reglas de idioma español
        toTitleCase(value) {
            if (!value || typeof value !== "string") return "";
            const normalized = value
                .toLocaleLowerCase("es-CO")
                .replace(/\s+/g, " ")
                .trim();
            return normalized.replace(/\b([\p{L}ÁÉÍÓÚÑáéíóúñ]+)\b/gu, (w) =>
                w.charAt(0).toLocaleUpperCase("es-CO") + w.slice(1)
            );
        },
        // Sincroniza el scroll del header con el body
        syncScroll() {
            if (this.$refs.headerWrapper && this.$refs.bodyWrapper) {
                this.$refs.headerWrapper.scrollLeft = this.$refs.bodyWrapper.scrollLeft;
            }
        },
        animateValue(key, start, end) {
            start = Number(start);
            end = Number(end);
            
            // Si ya existe el valor animado, retornarlo
            if (this.animatedDownloads[key] !== undefined) {
                return this.formatNumber(this.animatedDownloads[key]);
            }
            
            const duration = Math.min(1000 + Math.log10(Math.max(end, 1)) * 200, 2000);
            const frameRate = 30;
            const totalFrames = Math.round((duration / 1000) * frameRate);
            let currentFrame = 0;
            const increment = (end - start) / totalFrames;
            
            if (this._intervals && this._intervals[key]) {
                clearInterval(this._intervals[key]);
            }
            if (!this._intervals) this._intervals = [];
            
            this.$set(this.animatedDownloads, key, start);
            
            this._intervals[key] = setInterval(() => {
                currentFrame++;
                this.$set(this.animatedDownloads, key, start + increment * currentFrame);
                if (currentFrame >= totalFrames) {
                    clearInterval(this._intervals[key]);
                    this.$set(this.animatedDownloads, key, end);
                }
            }, duration / totalFrames);
            
            return this.formatNumber(this.animatedDownloads[key] || start);
        },
        getUserInitials(name) {
            const normalized = this.toTitleCase(name);
            if (!normalized) return '??'
            const words = normalized.trim().split(' ')
            if (words.length === 1) {
                return words[0].substring(0, 2).toUpperCase()
            }
            return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase()
        },
        formatNumber(num) {
            if (num >= 1000000) {
                return (num / 1000000).toFixed(1) + 'M'
            }
            if (num >= 1000) {
                return (num / 1000).toFixed(1) + 'K'
            }
            return Math.round(num).toString()
        },
        formatTime(seconds) {
            if (!seconds || seconds === '0') return '0h 0m';
            
            const totalSeconds = parseInt(seconds);
            const hours = Math.floor(totalSeconds / 3600);
            const minutesInSeconds = totalSeconds % 3600;
            const minutes = Math.floor(minutesInSeconds / 60);
            const remainingSeconds = minutesInSeconds % 60;
            
            const finalMinutes = remainingSeconds > 0 ? minutes + 1 : minutes;
            
            return `${hours}h ${finalMinutes}m`;
        },
        getRankClass(index) {
            if (index === 0) return 'rank-first'
            if (index === 1) return 'rank-second'
            if (index === 2) return 'rank-third'
            return 'rank-default'
        },
        initAnimatedDownloads() {
            // Limpiar animaciones anteriores
            if (this._intervals) {
                Object.values(this._intervals).forEach(interval => clearInterval(interval));
            }
            this._intervals = {};
            this.animatedDownloads = {};
        }
    },
    beforeDestroy() {
        if (this._intervals) {
            Object.values(this._intervals).forEach(interval => clearInterval(interval));
        }
    }
}
</script>

<style scoped>
.card {
    position: relative;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 25px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.card-body{
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    max-height: 500px;
}

.chart-wrapper {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
}

.chart-header {
    display: flex;
    align-items: center;
    margin-bottom: 0.75rem;
}

.chart-title {
    position: relative;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 800;
    color: #1B212E;
    z-index: 1;
}

.ranking-container {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.table-header-row {
    background-color: #f8fafc;    
}
.table-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.table-header-wrapper {
    overflow-x: auto;
    overflow-y: visible;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex-shrink: 0;
}

.table-header-wrapper::-webkit-scrollbar {
    display: none;
}

.table-header-wrapper table {
    margin-bottom: 0;
}

.table-body-wrapper {
    flex: 1;
    overflow-y: auto;
    overflow-x: auto;
    min-height: 0;
    position: relative;
}

.table-body-wrapper::-webkit-scrollbar {
    width: 12px;
    height: 12px;
}

.table-body-wrapper::-webkit-scrollbar-track {
    background: #e2e8f0;
    border-radius: 10px;
    margin: 4px 0;
}

.table-body-wrapper::-webkit-scrollbar-thumb {
    background: #94a3b8;
    border-radius: 10px;
    border: 3px solid #e2e8f0;
    height: 100px;
}

.table-body-wrapper::-webkit-scrollbar-thumb:hover {
    background: #64748b;
    border-color: #cbd5e1;
}


.ranking-table {
    margin: 0;
    width: 100%;
    min-width: 800px;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
}

.table-body-wrapper .ranking-table {
    margin-top: 0;
}

.ranking-table thead th {
    background-color: #f8fafc;
    border: none;
    border-bottom: 2px solid #e2e8f0;
    font-weight: 600;
    font-size: 13px;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 12px 16px;
}

.sortable-header {
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;
    position: relative;
}

.sortable-header-content {
    display: inline-flex;
    align-items: center;
    gap: 2px;
}

.sortable-header:hover {
    background-color: #e2e8f0;
    color: #0CB1F7;
}

.sort-icon {
    margin-left: 6px;
    display: inline-block;
    font-size: 12px;
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

.sortable-header:hover .sort-icon {
    opacity: 1;
}

.user-row {
    transition: all 0.2s ease;
    border-bottom: 1px solid #f1f5f9;
}

.user-row:hover {
    background-color: #f8fafc;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.user-row.top-user {
    background: linear-gradient(90deg, rgba(12, 177, 247, 0.03) 0%, rgba(255, 255, 255, 0) 100%);
}

.user-row td {
    vertical-align: middle;
    border: none;
    padding: 12px 16px;
}

.rank-header,
.rank-cell {
    width: 5%;
    text-align: center;
}

.user-header,
.user-cell {
    width: 35%;
}

.time-header,
.time-cell {
    width: 15%;
}

.downloads-header,
.downloads-cell {
    width: 15%;
}

.rank-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    font-weight: 700;
    font-size: 14px;
}

.rank-first {
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    color: #92400e;
    box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
}

.rank-second {
    background: linear-gradient(135deg, #c0c0c0, #e5e7eb);
    color: #374151;
    box-shadow: 0 2px 8px rgba(192, 192, 192, 0.3);
}

.rank-third {
    background: linear-gradient(135deg, #cd7f32, #f59e0b);
    color: #92400e;
    box-shadow: 0 2px 8px rgba(205, 127, 50, 0.3);
}

.rank-default {
    background-color: #f1f5f9;
    color: #64748b;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.user-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, #0CB1F7, #0ea5e9);
    color: white;
    font-weight: 700;
    font-size: 16px;
    box-shadow: 0 2px 8px rgba(12, 177, 247, 0.25);
    transition: transform 0.2s ease;
}

.user-row:hover .user-avatar {
    transform: scale(1.05);
}

.user-details {
    flex: 1;
}

.user-name {
    font-weight: 600;
    color: #1e293b;
    font-size: 15px;
    line-height: 1.2;
}

.user-status {
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
}

.time-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.time-value {
    font-weight: 600;
    color: #1e293b;
    font-size: 15px;
}

.time-label {
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
}

.downloads-info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.downloads-value {
    font-weight: 700;
    color: #0CB1F7;
    font-size: 16px;
}

.downloads-trend {
    font-size: 12px;
}

.trend-up {
    color: #10b981;
}

.trend-down {
    color: #ef4444;
}

.empty-state {
    text-align: center;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
}

.empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
}

.empty-text {
    color: #64748b;
    font-size: 16px;
    margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
    .ranking-table {
        font-size: 13px;
        min-width: 700px;
    }

    .user-avatar {
        width: 36px;
        height: 36px;
        font-size: 14px;
    }

    .chart-title {
        font-size: 16px;
    }
    
    .rank-header,
    .rank-cell {
        width: 8%;
    }

    .time-header,
    .time-cell {
        width: 18%;
    }

    .downloads-header,
    .downloads-cell {
        width: 18%;
    }
    
    .user-header,
    .user-cell {
        width: 30%;
    }
    
    .ranking-table thead th,
    .user-row td {
        padding: 10px 12px;
    }
}

@media (max-width: 576px) {
    .ranking-table {
        font-size: 12px;
        min-width: 650px;
    }
    
    .user-avatar {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }
    
    .chart-title {
        font-size: 14px;
    }
    
    .ranking-table thead th,
    .user-row td {
        padding: 8px 10px;
    }
    
    .user-name {
        font-size: 13px;
    }
    
    .time-value,
    .downloads-value {
        font-size: 14px;
    }
}
</style>